import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsBuilding from "graphql/fields/FieldsBuilding";

const fields = {
	'guid': 'String',
	'name': 'String!',
	'capacity': 'Int',
	'position': 'Int',
	'available_for': 'String',
	'aed': 'String',
	'address_postal_code': 'String',
	'kind': 'String!',
	'active': 'String!',
};

export default gql(`
	mutation building( ${ HelperGraphql.createFields( fields ) } ) {
	    building( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsBuilding}
	    }
	}
`);

